// extracted by mini-css-extract-plugin
export default {"container":"style_container__IH5Is","loader":"style_loader__PfR++"};